import React from 'react';
import {
  Cell,
  DateTimeField, Header4,
  TextField,
  TextLink,
  usePopupManager
} from 'ui-builder';
import {
  WebhookRequestLogEntry,
  useWebhookMonitoringService,
  WebhookSubscription
} from 'nekst-api';
import { ShowMoreTextField } from '../../../../shared/widgets/ShowMoreTextWrapper';
import { useShowContextRequired } from 'ui-builder';
import LoadMorePaginationList from '../../../../shared/uibuilder/list/LoadMorePaginationList';
import { useSubscriptionEventHelper } from '../subscriptionEventHelper';
import InfiniteScrollWrapper from '../../../../shared/uibuilder/list/layout/InfiniteScrollWrapper';
import {
  GridLayout,
  InformationMessage,
  Popup,
  SelectForMassUpdateCheckbox
} from 'features/nekst-widgets';
import WebhookRequestLogInfo from './WebhookRequestLogInfo';
import MassUpdateControlsLayout
  from '../../../../shared/widgets/MassUpdate/MassUpdateControlsLayout';
import RepeatRequestButton from './massupdate/RepeatRequestButton';

interface WebhookRequestsLogEntriesListProps {
  subscriptionId: number;
}

function DownloadRequestLink() {
  const popupManager = usePopupManager();

  const showContext = useShowContextRequired<WebhookRequestLogEntry>();

  return (
    <TextLink
      onClick={() => {
        popupManager.openPopup(
          <Popup
            title="Request"
            content={<WebhookRequestLogInfo request={showContext.data!} />}
          />
        )
      }}
    >
      Show Request
    </TextLink>
  );
}

function EventType() {
  const { data } = useShowContextRequired<WebhookRequestLogEntry>();

  const helper = useSubscriptionEventHelper();

  return (
    <>
      {helper.getLabel(data!.event)}
      {' '}
      (id: {data?.referenceId})
    </>
  );
}

export default function WebhookRequestsLogEntriesList(props: WebhookRequestsLogEntriesListProps) {
  const webhookMonitoringService = useWebhookMonitoringService();

  const { data: subscription } = useShowContextRequired<WebhookSubscription>();

  return (
    <LoadMorePaginationList
      getDataFunc={async (filter, nextPageToken
      ) => {
        return await webhookMonitoringService.getHistory({
          subscriptionId: props.subscriptionId,
          limit: 20,
          fromTimestamp: nextPageToken as number | undefined,
        });
      }}
    >
      <InfiniteScrollWrapper>
        <Header4>Requests Log</Header4>
        <InformationMessage>
          The log contains records from the past 30 days.
          {!subscription.isEnabled && ' The webhook is currently disabled, and the system is not sending requests to it. Please enable the webhook to resume functionality.'}
        </InformationMessage>
        {subscription.isEnabled && (<MassUpdateControlsLayout hideSelectAll>
          <RepeatRequestButton />
        </MassUpdateControlsLayout>)}
        <GridLayout noDataMessage="No requests yet.">
          {subscription!.isEnabled ? (
            <Cell label="" testId={'massUpdate'} small>
              <SelectForMassUpdateCheckbox />
            </Cell>
          ) : null}
          <Cell label="When">
            <DateTimeField source="when" />
          </Cell>
          <Cell label="Event">
            <EventType />
          </Cell>
          <Cell label="Status">
            <ShowMoreTextField source="result" />
          </Cell>
          <Cell label="Attempts">
            <TextField source="numberOfAttempts" />
          </Cell>
          <Cell label="" testId="actions">
            <DownloadRequestLink />
          </Cell>
        </GridLayout>
      </InfiniteScrollWrapper>
    </LoadMorePaginationList>
  );
}
